import React from "react";

const Tips = ({ row }) => {
  return (
    <div>
      {row.tips === "" ? (
        ""
      ) : (
        <>
          <div>{row.tips?.cashTips?.toLocaleString()}</div>
          <div>{row.tips?.ccTips?.toLocaleString()}</div>
          <div>{row.tips?.eccTips?.toLocaleString()}</div>
          <div>0</div>
          <div>{row.tips?.compTips?.toLocaleString()}</div>
          <div>
            {row.tips?.eliteTips ? row.tips?.eliteTips?.toLocaleString() : 0}
          </div>

          <div style={{ borderTop: "1px dashed black" }}>
            <p>{row?.tips?.serviceTipsSum?.toLocaleString()}</p>
          </div>
        </>
      )}
    </div>
  );
};

export default Tips;
